import { DepartmentCalendar } from 'types/interfaces';

export const DepartmentCalendarTemplate: DepartmentCalendar = {
  id: 0,
  calendarId: 0,
  departmentId: 0,
  startDate: '',
  endDate: ''
};
